module.exports = __webpack_public_path__ + "static/media/icon-copy.0e7b4050.svg";